// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"63":"98045ee6","169":"8cc7d650","216":"4f035ab2","623":"e9988327","677":"8362706e"}[chunkId] + ".css";
};